module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?418d54a4a9df0e7b3e28dc09e4cce808";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = r0Cr
// module chunks = 29